module.exports = __webpack_public_path__ + "static/media/fassbsurvey-1.2b064e13.PNG";